import type dayjs from 'dayjs';
import { Model } from './model';
import { TransformStringToDayJS } from './utils';
import { LinkedIntegration } from './linked_integration';

export class LinkedIntegrationWebhookLog extends Model {
  id: string;

  entity_id: string | null;

  entity_type: string | null;

  @TransformStringToDayJS()
  event_time: dayjs.Dayjs;

  event_type: string;

  payload: Record<string, any>;

  @TransformStringToDayJS()
  processed_at: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  received_at: dayjs.Dayjs;

  remote_entity_id: string;

  remote_event_name: string;

  linked_integration?: LinkedIntegration;
}
